import React from "react";

// Classnames
import clsx from "clsx";

// Components
import TableRow from "./TableRow";
import TableHeader from "./TableHeader";

// Constants
import { tableSolubilitiesHeader } from "constans/molecule-product";

// Type
import { ItemSolubility } from "pages/MoleculeProduct/reducer";

// Interface
interface ITable {
  className?: string,
  columns?: Column[],
  data?: ItemSolubility[],
}

// Type
export type Column = {
  data?: string,
  title?: string,
  className?: string,
}

export const TableSolubilities: React.FC<ITable> = (props) => {
  const key = "measure";
  const { data, columns, className } = props;

  const cleanedData = data?.map(item => {
    if (key in item && item.measure === "=") {
      const { measure, ...rest } = item;
      return rest;
    }
    return item;
  });
  const hasMeasureColumn = cleanedData?.some(item => key in item);
  const filteredColumns = columns?.filter(column => {
    if (column.data === key) {
      return hasMeasureColumn;
    }
    return true;
  }).map(x => x.data);

  const getTypeCell = (cell: string, currentData: ItemSolubility) => {
    switch (cell) {
      case tableSolubilitiesHeader[0].data:
        return {
          solvent: currentData.solvent
        };
        break;
      case tableSolubilitiesHeader[1].data:
        return {
          measure: "measure" in currentData ? currentData.measure : ""
        };
        break;
      case tableSolubilitiesHeader[2].data:
        return {
          conc: currentData?.conc ? currentData?.conc : ""
        };
        break;
      case tableSolubilitiesHeader[3].data:
        return {
          unit: currentData?.unit ? currentData.unit : ""
        };
        break;
      case tableSolubilitiesHeader[4].data:
        return {
          comment: currentData?.comment ? currentData.comment : ""
        };
        break;

      default:
        return {
          unit: "",
          conc: "",
          comment: "",
          solvent: "",
          measure: ""
        };
        break;
    }
  };

  const prepareData = (arr: ItemSolubility[]) => {
    const filteredColumns = columns?.map((x) => x.data);

    return arr.map((elem) =>
      filteredColumns?.map((item) =>
        getTypeCell(item || "", elem)));
  };

  const tableConfig = {
    data: prepareData(cleanedData || []),
    headers: columns?.filter(column => filteredColumns?.includes(column.data))
  };

  const cn = clsx("table-solubilities", className ? className : "");

  return <div className={cn}>
    <div className="table-solubilities__header flex flex-ai-center flex-jc-between">
      {tableConfig?.headers?.map((item, i) => (
        <TableHeader data={item} key={`${item.title}_${i}`} />
      ))}
    </div>

    {tableConfig.data.map((data, i) => (
      <TableRow data={data} key={`table-row_${i}`} />
    ))}
  </div>;
};

export default TableSolubilities;
